<template>
  <div inline class="mgt-18" v-if="btns.length > 0">
    <el-button
      plain
      size="small"
      @click="exec(v.btnCode)"
      v-for="(v, i) in btns"
      :key="i"
      :type="v.btnCode == 'del' ? 'danger' : ''"
      >{{ v.btnName }}</el-button
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      btns: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        // 动态路由已携带当前菜单的按钮权限，首屏和切换页面都以它为准。
        this.initBtn(route && route.meta && route.meta.btns);
      },
    },
  },
  methods: {
    initBtn(btns) {
      // 复制后排序，避免直接修改路由 meta 中的权限数组。
      this.btns = (Array.isArray(btns) ? btns.slice() : []).sort(
        (first, second) => Number(first.sort || 0) - Number(second.sort || 0)
      );
    },
    exec(fun) {
      this.$emit("exec", fun);
    },
  },
};
</script>
